module.exports = __webpack_public_path__ + "img/science_thumbnail-400x300.f448d80d.jpg";